module.exports = __webpack_public_path__ + "img/process-delete-hover.098f45c5.svg";